import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/win3.css';
import './styles/main.css';

// Install fetch interceptor for Zcash gRPC-web compatibility BEFORE retry wrapper
// This must be loaded first so it wraps the native fetch, then retry wraps our interceptor
import './components/toolbox/zcash-extensions/utils/fetch-interceptor';

// Initialise global network retry wrappers (fetch + axios) as early as possible
import './services/network/retry';
// Auxiliary entropy pool for seed generation (started below, once the
// import block is done).
import { startEntropyCollection } from './services/secureEntropy';
// Suppress noisy wallet provider connection errors (e.g., MetaMask not installed)
import './services/errors/walletErrorSuppressor';
// Reown AppKit (the WalletConnect modal) used to be eager-imported here
// to "init before React renders". In practice nothing needs the modal
// before the user clicks Connect, and pulling it in synchronously was
// adding ~1.5MB of @reown / @walletconnect to the boot bundle.
//
// services/client.impl.js (lazy-loaded on first wallet op) and
// Winbit32.jsx (lazy app) both import config/reown dynamically when
// they actually need the modal, so initialisation is deferred to that
// point. Worst case: a few hundred ms extra latency on the very first
// "Connect" click; everyone else pays nothing.
import App from './App';

import reportWebVitals from './reportWebVitals';

// Start stirring pointer/keyboard timings into the auxiliary entropy pool.
// Seed generation always uses the platform CSPRNG; this is independent
// material mixed in alongside it, so a degraded or compromised CSPRNG is
// not on its own sufficient to predict a generated phrase.
startEntropyCollection();

// ethers v6 lets any code replace its crypto primitives at runtime —
// randomBytes, computeHmac, pbkdf2, sha256/512, keccak256, ripemd160 and
// both scrypts all expose a global `.register()`, unlocked by default.
// One compromised lazily-loaded chunk calling
// `randomBytes.register(() => attackerBytes)` would hand over every key
// ethers derives afterwards, and no self-test could tell: the attacker's
// function can return output that passes every statistical test we have,
// because it only has to look random to us, not to them.
//
// `lock()` closes that for anything loading later, which here is nearly
// everything — ethers is deliberately kept out of the boot bundle and
// arrives with the first wallet operation. Deferred to idle so we do not
// pull that chunk forward into first paint.
//
// Honest limit: lock() prevents FUTURE registration. It cannot verify
// that the implementation currently installed is the original one, so it
// is a window-closing measure, not an integrity check.
const lockEthersCrypto = () => {
	import('ethers')
		.then(({ lock }) => lock?.())
		.catch(() => { /* ethers absent or already locked — neither is fatal */ });
};
if (typeof requestIdleCallback === 'function') requestIdleCallback(lockEthersCrypto);
else setTimeout(lockEthersCrypto, 3000);

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <>


    <App />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
